import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getEstadosUsuarios,
  getEstadoUsuarioById,
  updateEstadoUsuario,
  deleteEstadoUsuario,
  inserEstadoUsuario,
} from 'services/usuario'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ESTADOS_USUARIOS() {
  try {
    const resultData = yield call(getEstadosUsuarios)
    if (resultData.ok) {
      yield put({
        type: actions.ESTADOS_USUARIOS_LOAD_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Estados de Usuarios')
      put({
        type: actions.ESTADOS_USUARIOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTADOS_USUARIOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ESTADOS_USUARIOS(action) {
  try {
    const resultData = yield call(inserEstadoUsuario, action.payload)
    if (resultData.ok) {
      putMessage(messageType.SUCCESS, 'Estado de usuario creado correctamente')
      yield put({
        type: actions.ESTADOS_USUARIOS_INSERT_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear el estado de usuario')
      yield put({
        type: actions.ESTADOS_USUARIOS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear el estado de usuario')
    yield all([
      put({
        type: actions.ESTADOS_USUARIOS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ESTADOS_USUARIOS(action) {
  try {
    const resultData = yield call(updateEstadoUsuario, action.payload)
    if (resultData.ok) {
      putMessage(messageType.SUCCESS, 'Estado de usuario modificado correctamente')
      yield put({
        type: actions.ESTADOS_USUARIOS_UPDATE_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el estado de usuario')
      yield put({
        type: actions.ESTADOS_USUARIOS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el estado de usuario')
    yield all([
      put({
        type: actions.ESTADOS_USUARIOS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ESTADOS_USUARIOS(action) {
  try {
    const resultData = yield call(deleteEstadoUsuario, action.payload)
    if (resultData.ok) {
      putMessage(messageType.SUCCESS, 'Estado de usuario eliminado correctamente')
      yield put({
        type: actions.ESTADOS_USUARIOS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el estado de usuario')
      yield put({
        type: actions.ESTADOS_USUARIOS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el estado de usuario')
    yield all([
      put({
        type: actions.ESTADOS_USUARIOS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTADOS_USUARIOS_BY_ID(action) {
  try {
    const resultData = yield call(getEstadoUsuarioById, action.payload)
    if (resultData.ok) {
      yield put({
        type: actions.ESTADOS_USUARIOS_LOAD_BY_ID_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar el estado de usuario')
      put({
        type: actions.ESTADOS_USUARIOS_LOAD_BY_ID_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTADOS_USUARIOS_LOAD_BY_ID_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ESTADOS_USUARIOS_LOAD_REQUESTED, GET_ESTADOS_USUARIOS),
    takeEvery(actions.ESTADOS_USUARIOS_LOAD_BY_ID_REQUESTED, GET_ESTADOS_USUARIOS_BY_ID),
    takeEvery(actions.ESTADOS_USUARIOS_INSERT_REQUESTED, INSERT_ESTADOS_USUARIOS),
    takeEvery(actions.ESTADOS_USUARIOS_UPDATE_REQUESTED, UPDATE_ESTADOS_USUARIOS),
    takeEvery(actions.ESTADOS_USUARIOS_DELETE_REQUESTED, DELETE_ESTADOS_USUARIOS),
  ])
}
